/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Geo_Label_Western_AfricaInputs */

const bn_geo_label_western_africa = /** @type {(inputs: Geo_Label_Western_AfricaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`পশ্চিম আফ্রিকা`)
};

const de_geo_label_western_africa = /** @type {(inputs: Geo_Label_Western_AfricaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Westafrika`)
};

const el_geo_label_western_africa = /** @type {(inputs: Geo_Label_Western_AfricaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Δυτική Αφρική`)
};

const en_geo_label_western_africa = /** @type {(inputs: Geo_Label_Western_AfricaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Western Africa`)
};

const es_geo_label_western_africa = /** @type {(inputs: Geo_Label_Western_AfricaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`África occidental`)
};

const fr_geo_label_western_africa = /** @type {(inputs: Geo_Label_Western_AfricaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Afrique de l’Ouest`)
};

const hi_geo_label_western_africa = /** @type {(inputs: Geo_Label_Western_AfricaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`पश्चिमी अफ़्रीका`)
};

const hu_geo_label_western_africa = /** @type {(inputs: Geo_Label_Western_AfricaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nyugat-Afrika`)
};

const id_geo_label_western_africa = /** @type {(inputs: Geo_Label_Western_AfricaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Afrika Barat`)
};

const it_geo_label_western_africa = /** @type {(inputs: Geo_Label_Western_AfricaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Africa occidentale`)
};

const ja_geo_label_western_africa = /** @type {(inputs: Geo_Label_Western_AfricaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`西アフリカ`)
};

const ko_geo_label_western_africa = /** @type {(inputs: Geo_Label_Western_AfricaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`서부 아프리카`)
};

const nl_geo_label_western_africa = /** @type {(inputs: Geo_Label_Western_AfricaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`West-Afrika`)
};

const pl_geo_label_western_africa = /** @type {(inputs: Geo_Label_Western_AfricaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Afryka Zachodnia`)
};

const pt_geo_label_western_africa = /** @type {(inputs: Geo_Label_Western_AfricaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`África Ocidental`)
};

const ru_geo_label_western_africa = /** @type {(inputs: Geo_Label_Western_AfricaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Западная Африка`)
};

const sv_geo_label_western_africa = /** @type {(inputs: Geo_Label_Western_AfricaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Västafrika`)
};

const tr_geo_label_western_africa = /** @type {(inputs: Geo_Label_Western_AfricaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Batı Afrika`)
};

const uk_geo_label_western_africa = /** @type {(inputs: Geo_Label_Western_AfricaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Західна Африка`)
};

const vi_geo_label_western_africa = /** @type {(inputs: Geo_Label_Western_AfricaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tây Phi`)
};

const zh_geo_label_western_africa = /** @type {(inputs: Geo_Label_Western_AfricaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`西非`)
};

const zh_hant_geo_label_western_africa = /** @type {(inputs: Geo_Label_Western_AfricaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`西非`)
};

/**
* | output |
* | --- |
* | "Western Africa" |
*
* @param {Geo_Label_Western_AfricaInputs} inputs
* @param {{ locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }} options
* @returns {LocalizedString}
*/
export const geo_label_western_africa = /** @type {((inputs?: Geo_Label_Western_AfricaInputs, options?: { locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Geo_Label_Western_AfricaInputs, { locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "bn") return bn_geo_label_western_africa(inputs)
	if (locale === "de") return de_geo_label_western_africa(inputs)
	if (locale === "el") return el_geo_label_western_africa(inputs)
	if (locale === "en") return en_geo_label_western_africa(inputs)
	if (locale === "es") return es_geo_label_western_africa(inputs)
	if (locale === "fr") return fr_geo_label_western_africa(inputs)
	if (locale === "hi") return hi_geo_label_western_africa(inputs)
	if (locale === "hu") return hu_geo_label_western_africa(inputs)
	if (locale === "id") return id_geo_label_western_africa(inputs)
	if (locale === "it") return it_geo_label_western_africa(inputs)
	if (locale === "ja") return ja_geo_label_western_africa(inputs)
	if (locale === "ko") return ko_geo_label_western_africa(inputs)
	if (locale === "nl") return nl_geo_label_western_africa(inputs)
	if (locale === "pl") return pl_geo_label_western_africa(inputs)
	if (locale === "pt") return pt_geo_label_western_africa(inputs)
	if (locale === "ru") return ru_geo_label_western_africa(inputs)
	if (locale === "sv") return sv_geo_label_western_africa(inputs)
	if (locale === "tr") return tr_geo_label_western_africa(inputs)
	if (locale === "uk") return uk_geo_label_western_africa(inputs)
	if (locale === "vi") return vi_geo_label_western_africa(inputs)
	if (locale === "zh") return zh_geo_label_western_africa(inputs)
	return zh_hant_geo_label_western_africa(inputs)
});